// extracted by mini-css-extract-plugin
export default {"component":"FAQSection__component-QQFt","faqWrapper":"FAQSection__faqWrapper-yRxb"};